import { Action, combineReducers } from 'redux';

import { NavigationState } from '../state/NavigationState';
import { navLocationReducer } from './NavLocationReducer';
import { previousUrlReducer } from './PreviousUrlReducer';

export const navigationReducer: (
  previousState: NavigationState,
  action: Action
) => NavigationState = combineReducers<NavigationState>(
  {
    navLocation: navLocationReducer,
    previousUrl: previousUrlReducer
  }
);
